import React, {Component} from 'react';

import "@fortawesome/react-fontawesome";
import {request} from "../../../helper/APIUtils";
import Table from "../../../components/Table/Table";
import CreateEndpoint from "./CreateEndpoint";

import Alert from "react-s-alert";
import {showAxiosError} from "../../../helper/helper";
import UpdateEndpoint from "./UpdateEndpoint";
import {Button, ButtonGroup, Row} from "react-bootstrap";
import Swal from "sweetalert2";
import SweetAlert from "react-bootstrap-sweetalert";
import {Link} from "react-router-dom";


class EndpointList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: '',
            sectionData: [],
            endpointRecordId: null,
            alert: null
        }
        this.getSection = this.getSection.bind(this);
        this.deleteEndpoint = this.deleteEndpoint.bind(this);
        this.handleClickUpdateEndpoint = this.handleClickUpdateEndpoint.bind(this);
        this.handleClickCreateEndpoint = this.handleClickCreateEndpoint.bind(this);
    }


    componentDidMount() {
        this.getSection(this.props.sectionId);
    }


    componentWillUnmount() {
        this.props.isLoaded(false);
    }

    handleClickCreateEndpoint(data) {
        this.setState({modal: data});
    }

    handleClickUpdateEndpoint(data, endpointRecordId) {
        this.setState({modal: data, endpointRecordId: endpointRecordId});
    }

    getSection(sectionId) {
        let self = this;
        let params = {
            url: "/servicedocumentation/getSection?secId=" + sectionId,
            method: "get"
        };
        request(params)
            .then(function (response) {
                self.setState({sectionData: response.data})
            });
    }

    deleteEndpoint(id) {
        let self = this;
        let params = {
            url: "/servicedocumentation/deleteEndpoint?id=" + id,
            method: "post"
        };
        request(params)
            .then(function (response) {
                if (response.data === 'Deleted') {
                    Swal("Başarılı!", "Veri başarıyla silindi !", "success");
                    self.getSection(self.props.sectionId);
                }
            }).catch(function (error) {
            Swal("Hata !", error, "error");
            showAxiosError(error);
        });
    }

    render() {


        const columns = [
            {
                accessor: [
                    {Header: "İsim", accessor: "name"}
                ],
                Cell: row => (<div>{row.name} <br/></div>)
            },
            {
                accessor: [
                    {Header: "Açıklama", accessor: "explanation"}
                ],
                Cell: row => (<div>{row.explanation} <br/></div>)
            },
            {
                accessor: [
                    {Header: "Dönüş Değeri", accessor: "returnValue"}
                ],
                Cell: row => (<div>{row.returnValue} <br/></div>)
            },

            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                width: "11%",
                Cell: item => (
                    <div className="btn-group">
                        <ButtonGroup style={{float: "right"}}>
                            <Button size="sm"
                                    className="btnUpdate"
                                    title="Bu dokümantasyonu düzenlemek için tıklayın."
                                    onClick={() => this.handleClickUpdateEndpoint("updateEndpoint", item.recordId)}><i
                                className="fas fa-edit"/></Button>
                            <Button size="sm"
                                    className="btnDelete"
                                    title="Bu dokümantasyonu silmek için tıklayın."
                                    onClick={() => this.setState({
                                        alert: (<SweetAlert
                                            showCancel warning
                                            cancelBtnText="Hayır"
                                            confirmBtnText="Evet"
                                            confirmBtnBsStyle="danger"
                                            cancelBtnBsStyle="default"
                                            title="Bu İşlemi Yapmak İstediğinize Emin Misiniz?"
                                            onCancel={() => this.setState({alert: null})}
                                            onConfirm={() => this.deleteEndpoint(item.recordId) & this.setState({alert: null})}>
                                            {item.name+" adlı endpointi silmek üzeresiniz."}
                                        </SweetAlert>)
                                    })}><i
                                className="fas fa-minus"/></Button>

                        </ButtonGroup>
                    </div>
                )
            }
        ];
        return (
            <div>
                {this.state.alert}
                <div className="col-sm-12 mt-4">
                    <Row>
                        <Link
                            role="button"
                            type="button"
                            className="pull-left  btnBack btn-sm"
                            title="Geri gitmek için tıklayın."
                            to="/serviceDocumentation/add">
                            <i className="fas fa-arrow-left"/>
                        </Link>
                    </Row>
                    <h5 style={{marginTop: "30px"}}>{this.state.sectionData.name}</h5>
                    <Button
                        onClick={() => this.handleClickCreateEndpoint('createEndpoint')}
                        className="pull-right  btnAdd"
                        size="sm"
                        title="Dokümantasyon Oluşturmak için tıklayın.">
                        <i className="fas fa-plus"/>
                    </Button>
                    {this.state.sectionData.endpoint !== null && this.state.sectionData.endpoint !== undefined &&
                    <Table columns={columns}
                           total={this.state.sectionData.endpoint.length}
                           loadingText="Kayıtlar getiriliyor..."
                           content={this.state.sectionData.endpoint}
                           size={100}
                    />}
                </div>
                {this.state.modal === "createEndpoint" &&
                <CreateEndpoint onOpen={this.handleClickCreateEndpoint}
                                sectionRecordId={this.props.sectionId}
                                secName={this.state.sectionData.name}
                                docName={this.props.docName}
                                refresh={this.getSection}/>}

                {this.state.modal === "updateEndpoint" &&
                <UpdateEndpoint onOpen={this.handleClickUpdateEndpoint}
                                endpointRecordId={this.state.endpointRecordId}
                                sectionRecordId={this.state.sectionData.recordId}
                                docName={this.props.docName}
                                sectionName={this.state.sectionData.name}
                                refresh={this.getSection}> </UpdateEndpoint>
                }


            </div>
        );

    }
}

export default EndpointList;